<template>
  <div class="sidebar-item">
    <el-menu-item
      v-show="!item.children && item.toShow"
      class="has-no-children"
      @click="clickMenu(item)"
      :key="item.name + 'm'"
      :index="item.name + 'p'"
    >
      <i :class="`el-icon-${item.icon}`" v-if="item.parentId === 0"></i>
      <span slot="title">{{ item.label }} </span>
    </el-menu-item>
    <el-submenu
      :index="item.name + 'p'"
      :key="item.name + 's'"
      v-show="item.children && item.toShow"
      ref="subMenu"
      popper-append-to-body
    >
      <template slot="title">
        <i :class="`el-icon-${item.icon}`"></i>
        <span slot="title">{{ item.label }}</span>
      </template>
      <sidebar-item
        v-for="child in item.children"
        :key="child.path + 'i'"
        :item="child"
        :base-path="child.path"
        class="nest-menu"
      />
    </el-submenu>
  </div>
</template>
<script>
export default {
  name: "sidebarItem",
  data() {
    return {};
  },
  props: {
    item: {
      type: Object,
      default: () => {},
      required: true,
    },
    basePath: {
      type: String,
      required: true,
      default: "",
    },
  },
  components: {},
  methods: {
    //点击菜单 进行跳转
    clickMenu(item) {
      //当页面的路由于要跳转的路由不一致的时候  才允许进行跳转
      //$route指的是当前页面的路由      #router指的是挂在到vue对象上的总实例
      if (
        this.$route.path !== item.path &&
        !(this.$route.path === "/home" && item.path === "/")
      ) {
        this.$router.push(item.path);
      }
    },
  },
  computed: {},
  watch: {},
  mounted() {},
};
</script>
<style></style>
